@if (isUploadDocuments) {
  <div class="overlay" [class.show]="isUploadDocuments" >
    @if (isUploadDocuments) {
      <div class="off-canvas width-450"  [class.show]="isUploadDocuments">
        <div class="offCanvas__container">
          <div class="offCanvas__contentWrapper">
            <div class="usersFilter__headerWrapper">
              <div class="usersFilter__header">
                <div class="usersFilter__headerText">Upload Documents</div>
                <div class="usersFilter__headerImages">
                  <div class="usersFilter__border"></div>
                  <img (click)="close()" class="usersFilter__crossIcon"
                    src="../../../../assets/Images/user-management/Cross.svg" alt="close" />
                  </div>
                </div>
                <div class="documentType__dropdown">
                  <div class="documentType__dropdownLabel">
                    Document will save in  {{ toTitleCase(shipmentType) }} {{ toTitleCase(shipmentMode) }} Folder :
                  </div>
                  <select class="docType__dropdownOptions" [(ngModel)]="selectedFolder" disabled>
                    @for (option of subFolders; track option) {
                      <option [value]="option._id">
                        {{ option?.name }}
                      </option>
                    }
                  </select>
                </div>
                @if (!uploadingFile) {
                  <div style="display: flex; flex-direction: row; gap:  10px">
                    <div class="cursor-pointer card" (click)="file.click()">
                      <input style="display: none" #file type="file" accept="application/pdf" (change)="onFileSelected($event)" />
                      <div class="upload-icon text-secondary text-center">
                        <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
                      </div>
                      <div class="file-type-name" style="color: #6c757d">Upload</div>
                    </div>
                    @if (!scanDisabled) {
                      <div class=" card" (click)="scanDocument()">
                        <div class="upload-icon text-secondary text-center">
                          <img width="40" src="assets/Images/scanner.png" alt="">
                        </div>
                        <div class="file-type-name" style="color: #6c757d">Scan</div>
                      </div>
                    }
                  </div>
                }
                @if (uploadingFile) {
                  <div class="cardboard">
                    <div class="cursor-pointer card">
                      <div class="card_actions">
                        <app-common-icon (clickEvent)="deleteFile()"
                          [iconSrc]="'../../../assets/Images/document-preview/trash.svg'" [toolTip]="'Delete'"
                          [placement]="'right'"></app-common-icon>
                        @if (isScannedFile) {
                          <app-common-icon class="download_icon" [faIcon]="faDownload" ngbTooltip="Download"
                            placement="left" (clickEvent)="downloadFile()" [loadingIcon]="isLoading">
                          </app-common-icon>
                        }
                      </div>
                      <fa-icon [icon]="faFile" size="4x"></fa-icon>
                      <span class="file-name">{{ selectedFileName }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
            @if (errorMessage) {
              <div class="text-danger" >
                <p> {{errorMessage}}</p>
              </div>
            }
            <div class="offCanvas__footer">
              <app-common-button (clickEvent)="close()" buttonClass="smallbutton"
              buttonLabel="Cancel"></app-common-button>
              <app-common-button (clickEvent)="save()" buttonClass="smallFilledButton" [loadingIcon]="isLoader"
              buttonLabel="Save"   [disabled]="isSaveDisabled()"></app-common-button>
            </div>
          </div>
        </div>
      }
    </div>
  }
  <ng-template #licenceContent>
    <ul>
      @if (!companyPrefs['documentVault'].scanner) {
        <li class="document-info--container__Name">
          <small>You don't have a scanner access</small>
        </li>
      }
      @if (companyPrefs['documentVault'].scanner && !scannerLicence) {
        <li class="document-info--container__Name">
          <small>
          You don't have a scanner licence</small>
        </li>
      }
    </ul>
  </ng-template>

  <div class="overlay" [class.show]="isScanDocument"></div>
  <div class="off-canvas width-1000" [class.show]="isScanDocument">
    @if (isScanDocument) {
      <app-scan-document (closeEvent)="closeScanDoc($event)"></app-scan-document>
    }
  </div>
